<script setup lang="ts">
// COMPOSABLES
const { tt } = useTypedI18n();
const { availableVehicles } = useFleequidStats();
const { phones } = useFleequidContacts();
</script>

<template>
    <div class="bg-primary sticky inset-x-0 top-0 z-40 flex h-(--announcement-bar-height) items-center text-xs font-medium text-white">
        <!-- Desktop -->
        <BaseWidthContainer class="hidden w-full items-center justify-between lg:flex">
            <div class="flex items-center gap-3">
                <span>{{ tt('announcementBar.vehiclesInspected', { count: availableVehicles }) }}</span>
                <span class="text-white/50">·</span>
                <span>{{ tt('announcementBar.securePayments') }}</span>
                <span class="text-white/50">·</span>
                <span>{{ tt('announcementBar.warranty') }}</span>
            </div>
            <span class="inline-flex gap-1">
                {{ tt('announcementBar.callForAdvice') }}
                <BasePhoneLink v-for="phone in phones" :key="phone" class="text-white" :phone="phone" />
            </span>
        </BaseWidthContainer>

        <!-- Mobile: marquee -->
        <UMarquee :overlay="false" class="lg:hidden" :ui="{ root: '[--gap:--spacing(4)]' }">
            <span>{{ tt('announcementBar.vehiclesInspected', { count: availableVehicles }) }}</span>
            <span class="text-white/50">·</span>
            <span>{{ tt('announcementBar.securePayments') }}</span>
            <span class="text-white/50">·</span>
            <span>{{ tt('announcementBar.warranty') }}</span>
            <span class="text-white/50">·</span>
            <span class="inline-flex gap-1">
                {{ tt('announcementBar.callForAdvice') }}
                <BasePhoneLink v-for="phone in phones" :key="phone" class="text-white" :phone="phone" />
            </span>
            <span class="text-white/50">·</span>
        </UMarquee>
    </div>
</template>
